import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ForfeitureReasonForm from '../../../components/forms/ForfeitureReasonForm';
import { useForfeitureReasonById, useUpdateForfeitureReason } from '../../../hooks/useForfeitureReasonApi';
import { useNavigate, useParams } from 'react-router-dom';

const ForfeitureReasonEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData, isLoading } = useForfeitureReasonById(id!);
  const updateForfeitureReason = useUpdateForfeitureReason();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Forfeiture Reasons', href: '/admin/forfeiturereasons' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateForfeitureReason.mutateAsync({ id: id!, data });
      navigate('/admin/forfeiturereasons');
    } catch (error) {
      console.error('Error updating ForfeitureReason:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/forfeiturereasons"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ForfeitureReason.Edit'
    >
      {entityData ? (
        <ForfeitureReasonForm
          initialValues={entityData}
          onSubmit={handleSubmit}
          onCancel={() => navigate('/admin/forfeiturereasons')}
        />
      ) : (
        <p>Loading...</p>
      )}
    </AdminLayout>
  );
};

export default ForfeitureReasonEdit;
